import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import parse from 'html-react-parser';
import Controls from './Controls';
import { dateMoment } from '../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 15,
    paddingTop: 10,
    paddingBottom: 13,
    borderRadius: 8,
    border: '1px solid transparent',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'flex-end',
    },

    '&.isClosable': {
      paddingRight: 36,
      minHeight: 38,
    },

    '&.variant': {
      '&--default': {
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-color-alert-default)',
        borderColor: 'var(--color-border-alert-default)',
      },
      '&--success': {
        backgroundColor: 'var(--color-bg-alert-success)',
        color: 'var(--color-color-alert-success)',
        borderColor: 'var(--color-border-alert-success)',
      },
      '&--error': {
        backgroundColor: 'var(--color-bg-alert-error)',
        color: 'var(--color-color-alert-error)',
        borderColor: 'var(--color-border-alert-error)',
      },
      '&--warning': {
        backgroundColor: 'var(--color-bg-alert-warning)',
        color: 'var(--color-color-alert-warning)',
        borderColor: 'var(--color-border-alert-warning)',
      },
      '&--primary': {
        backgroundColor: 'var(--color-bg-alert-primary)',
        color: 'var(--color-color-alert-primary)',
        borderColor: 'var(--color-border-alert-primary)',
      },
      '&--info': {
        backgroundColor: 'var(--color-bg-alert-info)',
        color: 'var(--color-color-alert-info)',
        borderColor: 'var(--color-border-alert-info)',
      },
    },

    '&.text-part': {
      '&:empty': {
        display: 'none',
      },
    },
    '&.support-part': {
      '&:empty': {
        display: 'none',
      },
    },

    '& .section-1': {
      flex: 1,
      marginBottom: '-8px',
    },

    '& .section-2': {
      paddingTop: 8,

      [theme.breakpoints.up('md')]: {
        paddingLeft: 16,
      },
    },

    '& .title': {
      fontSize: 17,
      fontWeight: 600,
      letterSpacing: '-0.15px',
      color: 'inherit',
      marginBottom: 2,
    },

    '& .message': {
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: '-0.15px',
      color: 'var(--color-fontColors-grey-2)',
      marginBottom: 4,
      lineHeight: '23px',

      '& p': {
        marginBottom: 4,
        marginTop: 4,

        '&:first-child': {
          marginTop: 0,
        },

        '&:last-child': {
          marginBottom: 0,
        },
      },

      '& a': {
        color: 'var(--color-colorPrimary-main)',
        cursor: 'pointer',
      },
    },

    '& .date': {
      fontSize: 12,
      fontWeight: 400,
      letterSpacing: '-0.15px',
      color: '#797979',
    },

    '& .link': {
      marginBottom: 4,

      '& a': {
        color: 'var(--color-colorPrimary-main)',
        cursor: 'pointer',
      },
    },
  },
}));

const AdvancedAlert = ({
  variant = 'default',
  title,
  message,
  link,
  linkLabel = 'Read more',
  date,
  className = '',
  onClose,
}) => {
  const classes = useStyles();
  const isClosable = onClose ? true : false;

  return (
    <div
      className={`${classes.root} variant--${variant} ${
        isClosable ? 'isClosable' : ''
      } ${className}`}
    >
      <section className="section-1">
        <div className="text-part title">{title}</div>
        <div className="text-part message">{message ? parse(message) : ''}</div>
        <div className="text-part link">
          {link ? (
            <a href={link} target="_blank" rel="noopener noreferrer">
              {linkLabel}
            </a>
          ) : (
            ''
          )}
        </div>
      </section>
      <section className="section-2">
        <div className="support-part date">
          {date && dateMoment(date) ? dateMoment(date).format('DD/M/YYYY') : ''}
        </div>
      </section>
      <Controls onClose={onClose} />
    </div>
  );
};

export default AdvancedAlert;
